import { useAppStorage } from './storage'

interface InsuranceState {
  'Riscos Diversos': boolean
  'Prestamista': boolean
}

const STORAGE_KEY = 'insurance_decisions'

export function useInsuranceStorage() {
  const storage = useAppStorage()

  function getAllInsuranceDecisions(): Record<string, InsuranceState> {
    try {
      const stored = storage.get<Record<string, InsuranceState>>(STORAGE_KEY)
      return stored || {}
    }
    catch (error) {
      console.error('Error reading insurance decisions from storage:', error)
      return {}
    }
  }

  function getInsuranceDecision(projectId: string): InsuranceState | null {
    const decisions = getAllInsuranceDecisions()
    return decisions[projectId] || null
  }

  function saveInsuranceDecision(
    projectId: string,
    insuranceType: keyof InsuranceState,
    applied: boolean,
  ): void {
    try {
      const decisions = getAllInsuranceDecisions()

      if (!decisions[projectId]) {
        decisions[projectId] = {} as InsuranceState
      }

      decisions[projectId][insuranceType] = applied

      storage.set(STORAGE_KEY, decisions)
    }
    catch (error) {
      console.error('Error saving insurance decision to storage:', error)
    }
  }

  function clearInsuranceDecision(projectId: string): void {
    try {
      const decisions = getAllInsuranceDecisions()
      delete decisions[projectId]
      storage.set(STORAGE_KEY, decisions)
    }
    catch (error) {
      console.error('Error clearing insurance decision from storage:', error)
    }
  }

  function clearAllInsuranceDecisions(): void {
    try {
      storage.remove(STORAGE_KEY)
    }
    catch (error) {
      console.error('Error clearing all insurance decisions from storage:', error)
    }
  }

  function hasInsuranceDecision(projectId: string): boolean {
    const decisions = getAllInsuranceDecisions()
    return !!decisions[projectId]
  }

  function hasSpecificInsuranceDecision(projectId: string, insuranceType: keyof InsuranceState): boolean {
    const decisions = getAllInsuranceDecisions()
    return !!decisions[projectId] && insuranceType in decisions[projectId]
  }

  return {
    getInsuranceDecision,
    saveInsuranceDecision,
    clearInsuranceDecision,
    clearAllInsuranceDecisions,
    hasInsuranceDecision,
    hasSpecificInsuranceDecision,
  }
}
